<div [class]="rootClasses()">
  <!--
    One slot, whatever the branch: two ng-content with the same selector project into the first
    of them only, and the trigger of the other branch is never drawn.
  -->
  <!--
    The area is a drop target and a wide click target, never a control of its own: it always
    holds a real button, and a focusable box around a focusable button is nested-interactive.
    Keyboard and screen reader go through that button, whose activation bubbles up to here.
  -->
  @if (picking()) {
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -- the button inside is the keyboard path -->
    <div
      [class]="zoneClasses()"
      (click)="browse()"
      (dragover)="over($event, true)"
      (dragleave)="over($event, false)"
      (drop)="dropped($event)">
      @if (dropzone() && !trigger()) {
        <svg mib-icon name="upload" class="size-5 text-gray-700"></svg>
      }

      <ng-content select="[mibUploadTrigger]" />

      @if (!trigger()) {
        <button mibButton theme="secondary" size="sm" type="button" [disabled]="disabled()">
          @if (!dropzone()) {
            <svg mib-icon name="upload"></svg>
          }
          {{ browseLabel() }}
        </button>
      }

      @if (dropzone() && formats()) {
        <span class="text-sm/5 text-gray-500">{{ formats() }}</span>
      }
    </div>
  }

  @if (files().length) {
    <!--
      A box of their own, so a list too tall for its place scrolls without taking the drop area
      with it. It only ever scrolls when the page bounded this component; left unbounded, the
      list is as tall as it needs and the page scrolls, as before.
    -->
    <div class="mib-scrollbar flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto">
      @for (item of files(); track $index; let i = $index) {
        <div mibCard [class]="cardClasses">
          <div class="flex items-center gap-2.5">
            <svg mib-icon [name]="mark(item)" [class]="markClasses(item)"></svg>
            <span class="min-w-0 flex-1 truncate text-sm/5 font-medium text-gray-900">{{ item.name }}</span>
            <span [class]="statusClasses(item)">{{ status(item) }}</span>
            @if (failed(item)) {
              <button
                mibButton
                mode="flat"
                theme="secondary"
                size="sm"
                type="button"
                [attr.aria-label]="'Replace ' + item.name"
                (click)="browse()">
                <svg mib-icon name="refresh-cw"></svg>
              </button>
            }
            <button
              mibButton
              mode="ghost"
              theme="secondary"
              size="sm"
              type="button"
              [attr.aria-label]="removeLabel(item)"
              (click)="removed.emit({ file: item, index: i })">
              <svg mib-icon name="x"></svg>
            </button>
          </div>

          <mib-progress-bar size="lg" [progress]="progress(item)" [color]="tint(item)" />
        </div>
      }
    </div>
  }
</div>

<input #picker type="file" class="hidden" [multiple]="multiple()" [accept]="accept()" (change)="onPick($event)" />
